// extracted by mini-css-extract-plugin
module.exports = {"footer":"_2cmimjFMr2jUxueWaNgxD1"};